import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=c8e613c8&scoped=true"
var script = {}
import style0 from "./AuthError.vue?vue&type=style&index=0&id=c8e613c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e613c8",
  null
  
)

export default component.exports